import { createFileRoute, redirect, Navigate, useRouterState } from '@tanstack/react-router';
import { AdminOrganizationDetailPage } from '@/features/admin/admin-organization-detail-page';

export const Route = createFileRoute('/admin/organizations/$id')({
  beforeLoad: ({ params }) => {
    if (params.id === 'new') {
      throw redirect({ to: '/admin/organizations' });
    }
  },
  component: AdminOrganizationDetailRoute,
});

function AdminOrganizationDetailRoute() {
  const { id: paramId } = Route.useParams();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  // Fallback for cases where params are briefly unavailable during navigation/hydration.
  const fallbackId = pathname.match(/^\/admin\/organizations\/([^/]+)\/?$/)?.[1];
  const id = paramId || fallbackId;

  if (!id) {
    if (shouldRedirectToOrganizationListOnMissingId(pathname)) {
      return <Navigate to="/admin/organizations" replace />;
    }

    return null;
  }

  return <AdminOrganizationDetailPage organizationId={id} />;
}

export function shouldRedirectToOrganizationListOnMissingId(pathname: string): boolean {
  return pathname === '/admin/organizations' || pathname.startsWith('/admin/organizations/');
}
